/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".autocomplete-spinner{background-image:url(/odr/assets/images/spinner.gif);background-repeat:no-repeat;background-position:100%;background-size:contain}"];
export { styles as styles };
